import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Cam on SVG Icon for camera control button.
 */
export const CamOn: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 35 35"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M24.5278 14.7656V9.40625C24.5278 8.56406 23.8278 7.875 22.9722 7.875H4.30556C3.45 7.875 2.75 8.56406 2.75 9.40625V24.7188C2.75 25.5609 3.45 26.25 4.30556 26.25H13.6389H22.9722C23.8278 26.25 24.5278 25.5609 24.5278 24.7188V19.3594L30.75 25.4844V8.64062L24.5278 14.7656Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
